define('drops/entityFilter/filterInstance',[
    'underscore',
    'lq/constants',
    'lq/eventSource',
    'lq/design/editors/dropExtensionsClicks'
], function (_, constants, EventSource) {
    'use strict';

    var horizontalMargin = 10;

    var FilterInstance = function (filter, targetDrop, options, hasInitialValue) {
        EventSource.call(this, [
            'Removed',
            'EditingSettings',
            'SettingsApplied'
        ]);

        this.options = options;
        this.targetDrop = targetDrop;
        this.filter = filter;
        this.dropFactory = targetDrop.piping.dropFactory;
        this.hasInitialValue = hasInitialValue;
    };
    
    FilterInstance.currentPopup = null;
    
    FilterInstance.prototype.applyFilterToTarget = function () {
        if (!this.options.modalPopup)
            this.executeFilterChanges();
    };

    FilterInstance.prototype.applySettingsFromPopup = function () {
        this.hideSettingsPopup();
        this.executeFilterChanges();

        this.triggerSettingsApplied();
    };

    FilterInstance.prototype.hideSettingsPopup = function (isImmediate) {
        var popup = this.dropFactory.findDropByName(this.options.modalPopup);
        if (isImmediate) {
            popup.$element.hide();
        } else {
            popup.$element
                .fadeOut({
                    queue: false,
                    complete: function () {
                        popup.$element.show();
                        popup.hide();
                    }
                });
        }
    };

    FilterInstance.prototype.closeCurrentPopup = function () {
        if (FilterInstance.currentPopup) {
            FilterInstance.currentPopup.hideSettingsPopup(true);
            FilterInstance.currentPopup = null;
        }
    };

    FilterInstance.prototype.showSettingsPopup = function ($nextTo) {
        this.closeCurrentPopup();
        
        this.doReverseMappingToShowFilterValuesForCurrentTarget(this.options);

        var popup = this.dropFactory.findDropByName(this.options.modalPopup);
        popup.show();
        popup.$element
            .hide()
            .fadeIn({
                duration: 'slow',
                queue: false
            });
        var filterPosition = $nextTo.offset();
        var poolPosition = this.filter.rootDrop.$element.offset();
        popup.$element.css({
            positioning: 'absolute',
            top: filterPosition.top - poolPosition.top,
            left: filterPosition.left - poolPosition.left + $nextTo.outerWidth() + horizontalMargin,
            bottom: 'auto',
            right: 'auto',
            width: popup.data.size.x,
            height: popup.data.size.y
        });
        $nextTo.addClass('settings-is-open');

        FilterInstance.currentPopup = this;

        this.triggerEditingSettings();
    };

    FilterInstance.prototype.doReverseMappingToShowFilterValuesForCurrentTarget = function () {
        var parameters = this.targetDrop.piping.parameters;

        var self = this;
        _.each(this.options.mappings, function (mapping) {
            var sourceDrop = self.dropFactory.findDropByName(mapping.sourceName);

            sourceDrop.setValue({
                type: constants.valueTypes.string,
                value: parameters.getValue(mapping.targetParameter)
            });
        });
    };

    FilterInstance.prototype.executeFilterChanges = function () {
        var parameters = this.targetDrop.piping.parameters;

        if (this.options.filterParameterName)
            parameters.locals.setValue(this.options.filterParameterName, this.options.filterParameterValue);

        if (this.options.modalPopup) {
            var self = this;
            _.each(this.options.mappings, function (mapping) {
                var sourceDrop = self.dropFactory.findDropByName(mapping.sourceName);
                parameters.locals.setValue(mapping.targetParameter, sourceDrop.getValue());
            });
        }

        this.filter.triggerEventForTargetIfEnabled(this.options, 'applyFilter');

        if (this.options.executeQuery)
            this.targetDrop.executeQuery();
    };

    FilterInstance.prototype.resetFilter = function () {
        var parameters = this.targetDrop.piping.parameters;

        if (this.options.filterParameterName)
            parameters.locals.setValue(this.options.filterParameterName, this.options.filterParameterResetValue);

        if (this.options.modalPopup) {
            this.hideSettingsPopup();

            _.each(this.options.mappings, function (mapping) {
                parameters.locals.setValue(mapping.targetParameter, null);
            });
        }

        this.filter.triggerEventForTargetIfEnabled(this.options, 'resetFilter');
    };

    FilterInstance.prototype.remove = function (skipQueryExecution) {
        this.resetFilter();

        if (this.options.executeQuery && !skipQueryExecution)
            this.targetDrop.executeQuery();

        this.triggerRemoved();
    };
    
    return FilterInstance;
});
